export default "__VITE_ASSET__Th$aeq3f__"